import * as React from 'react'
import { styled } from 'next-yak'

import type { PolymorphicComponent, YakComponentOf } from '@owl-nest/yak/extra-runtime'

import * as S from '../../styles'
import { type StatusPastilleColor } from '../../styles/tag'

type StatusPillExtraProps = {
  color?: StatusPastilleColor
  bordered?: boolean
}

export type StatusPillProps = StatusPillExtraProps & React.HTMLAttributes<HTMLDivElement>

function StatusPillComponent({
  children,
  color = 'grey',
  ...props
}: StatusPillProps): React.ReactElement<StatusPillProps> {
  return (
    <S.tag.StatusPill $bordered={props.bordered} {...props} data-testid="component:statuspill">
      <S.tag.StatusPastille $color={color} />
      <S.copy.XS.regular>{children}</S.copy.XS.regular>
    </S.tag.StatusPill>
  )
}

export const StatusPill = styled(StatusPillComponent)<StatusPillProps>`` as YakComponentOf<
  PolymorphicComponent<'div', StatusPillExtraProps>
>
StatusPill.displayName = 'StatusPill'
